<template>
    <div class="bazis-club-page">
        <div class="container">
            <div class="section-title">
                <h1>{{pageSetup.page_title}}</h1>
            </div>
            <!-- <BanerTopVertical :options="[{page: 'bazis-club'}]" class="bazis-club-vertical-baner-top" v-if="banerSystem != undefined && banerSystem.baner_system_active == 'true'"></BanerTopVertical> -->
            <!-- <div class="section-title-desc">
                <h2>{{pageSetup.page_title_desc}}</h2>
            </div> -->

            <div class="bazis-club-desc-main">
                <div class="column-container">
                    <div class="col-left">
                        <div class="desc-main">
                            <p v-for="item in pageSetup.desc_red">{{item.desc}}</p>
                        </div>
                        <div class="col-img-mobile">
                            <img :src="pageSetup.desc_img" alt="">
                        </div>
                        <div class="desc-base">
                            <p v-html="pageSetup.title_red"></p>
                        </div>
                        <router-link :to="{name: 'contacts-sales'}" class="default-red-link sales-link">Офисы продаж</router-link>
                    </div>
                    <div class="col-right">
                        <div class="col-img">
                            <img :src="pageSetup.desc_img" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container container-club-vip-cards">
            <div class="bazis-club-vip-cards-container">
                <div class="cards-vip-title">
                    <h2>{{pageSetup.club_card.title}}</h2>
                </div>
                <div class="desc-info-container">
                    <div class="desc-info">
                        <div class="desc-info-text">
                            <p v-for="item in pageSetup.club_card.desc">{{item.desc}}</p>
                        </div>
                    </div>
                    <div class="vip-cards-table">
                        <div class="item" v-for="item in pageSetup.club_card.card_desc">
                            <div class="item-img">
                                <img :src="item.img" alt="">
                            </div>
                            <div class="item-info">
                                <ul>
                                    <li>{{item.how_flats}}</li>
                                    <li><svgIcon name="sale-pin"/>{{item.how_sale}}</li>
                                    <li>{{item.how_name}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="vip-cards-anounce">
                        <svgIcon name="anounce-new"/>
                        <p v-for="item in  pageSetup.club_card.imp_desc_left">{{item.desc}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bazis-club-category" v-if="bazisClubItems != null" id="bazis-club-category">
            <div class="container">
                <div class="section-title-second">
                    <h2>{{pageSetup.partners_title}}</h2>
                    <!-- <div class="partners-count">
                        <p>{{pageSetup.syntax.total}}<span class="count">{{bazisClubItems.length}}</span><span>{{pageSetup.syntax.partners}}</span></p>
                    </div> -->
                </div>
                <categoryItem></categoryItem>
            </div>
        </div>
        <formPage class="form-page-bazis-club"></formPage>
    </div>
</template>

<script>
    // import sharePostBottom from '@/components/share/share-social-bottom.vue'
	import formPage from '@/components/forms/form-page.vue';	
    import categoryItem from '@/components/bazis-club/bazis-club-category.vue'
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'bazis-club--page',
        components: {
            categoryItem,
            svgIcon,
            formPage,
        },
        data () {
            return {
                titlePage: 'Bazis Club',
            }
        },
        computed: mapGetters({
            pageSetup: 'loadBazisClub',
            bazisClubItems: 'loadBazisClubItems',
            titleSite: 'loadSiteTitle',
            banerSystem: 'loadBanerSystem',
        }),
        methods: {
            openBazisClubForm() {
                this.$store.commit('Open_form_bazis_Club', true);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
            }
        },
        beforeRouteEnter (to, from, next) {
            store.dispatch('getBazisClubItems');
            store.dispatch('getBazisClubCategoryCounter');
            if (store.state.bazisClub != null) {
                next(vm => {
                    setTimeout(() => {
                        vm.$parent.$refs.topProgress.done();
                    }, 300);
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getBazisClubPageData').then((response) => {
                    // console.log(response, 'asdasdasdasdas');
                    if (response) {
                        next(vm => {
                            vm.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'bazis-club';
        },
        created () {
            document.title = this.titlePage + ' - ' + this.titleSite;
            // document.title = this.title;
        },
        mounted() {
        }
    }
</script>



<style lang="scss">
    @import '@/styles/components/bazis-club/bazis-club.scss';
    @import '@/styles/respond/bazis-club/bazis-club-respond.scss';
</style>